import React, { useEffect, useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { Icon } from '@navent-jobs/ui-kit/components/icon'
import { openCart } from '../../../../store/cart-v2/modal/actionsToDo'
import {
  DetailContainer,
  DetailText,
  DetailSubText,
  ViewCartButton,
  DetailImgContainer,
  IconContainer,
  DetailSubTextBold,
  TextContainer,
} from './mixins'
import { formatNameProductCart } from '../../../../constants/ecommerce/format-name-products-cart'
import PopOver from '../index'
import { AppStore } from '../../../../store'
import { useFadeNotification } from '../../../../hooks/fade-notification-hook'
import { hideNotificationCart } from '../../../../store/cart-v2/notification/actionsToDo'
import { NotificationCartState } from '../../../../store/cart-v2/notification/types'

const Component = () => {
  const { open, selectedItem } = useSelector<AppStore, NotificationCartState>(
    ({ cartStoreV2 }) => cartStoreV2.notification
  )
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const buttonOpenCart = { size: 'medium', type: 'link', variant: 'primary' }
  const onClose = useCallback(() => dispatch(hideNotificationCart()), [])

  const { execute } = useFadeNotification({ callback: onClose })

  useEffect(() => {
    open && execute()
  }, [open])

  const { label, type, creditos, color, icon } = selectedItem || {}

  const onOpenCartClick = () => {
    dispatch(openCart())
    onClose()
  }
  const productName = formatNameProductCart({
    tipo: type ?? '',
    label: label ?? '',
    creditos: Number(creditos),
    t,
  }).split(' ')
  const last = productName.pop()
  const rest = productName.join(' ')
  return (
    <PopOver isOpen={open} onClose={onClose}>
      <DetailContainer>
        <DetailText>{t('cart.notification.addItem.title')}</DetailText>
        <DetailImgContainer>
          <IconContainer color={color}>
            <Icon name={icon ?? ''} size="18" color="#fff" />
          </IconContainer>
          <TextContainer>
            <DetailSubText>{rest}</DetailSubText>
            <DetailSubTextBold>{last}</DetailSubTextBold>
          </TextContainer>
        </DetailImgContainer>
        <ViewCartButton buttonoptions={buttonOpenCart} onClick={() => onOpenCartClick()}>
          {t('cart.notification.addItem.button.openCart')}
        </ViewCartButton>
      </DetailContainer>
    </PopOver>
  )
}

export default Component
